import axios from 'axios';
import UserEvents from '../events/user';

class UserAPI {
  constructor(APIDEFS) {
    this.data = {};
    this.API = APIDEFS;
    this.userEvents = new UserEvents();

    this.login = (userObj, reload = false, location = null) => {
      axios
        .post(`${window.APIDEF.base}${window.APIDEF.account}/login`, userObj, {
          headers: { 'Content-Type': 'application/JSON' },
        })
        .then(response => {

          if (response.data.success) {
            dispatchEvent(this.userEvents.login(response.data));
            window.APIDEF.userIsAuthenticated = true;
            if (typeof window.APIDEF.LoginKbMax === "function") {
              window.APIDEF.LoginKbMax(userObj);
            }
            if (reload) {
              window.location.reload(false);
            }
          } else {
            dispatchEvent(this.userEvents.loginFailed(response.data));
          }
        });
    };

    this.logout = () => {
      axios
        .get(`${window.APIDEF.base}${window.APIDEF.account}/logout`)
        .then(response => {
          window.location = window.APIDEF.logoutRedirectLocation;
        });
    };

    this.create = userObj => {
      axios
        .post(`${window.APIDEF.base}${window.APIDEF.account}/create`, userObj, {
          headers: { 'Content-Type': 'application/JSON' },
        })
        .then(response => {
          if (response.data.success) {
            dispatchEvent(this.userEvents.created(userObj));

          } else {
            dispatchEvent(this.userEvents.createFailed(response.data));
          }
        });
    };

    this.resetPasswordRequest = (email) => {
      axios
        .post(`${window.APIDEF.base}${window.APIDEF.account}/passwordreset`, { email }, {
          headers: { 'Content-Type': 'application/JSON' }
        })
        .then(response => {
          // console.log("resetPasswordRequest response:",response);
          dispatchEvent(this.userEvents.resetPasswordSent(response));
        });
    };

    this.setNewPassword = (email) => {
      axios
        .post(`${window.APIDEF.base}${window.APIDEF.account}/resetpassword`, { email }, {
          headers: { 'Content-Type': 'application/JSON' }
        })
        .then(response => {
          dispatchEvent(this.userEvents.resetPasswordSuccess(response));
        });
    };

  }
}

// debate whether to keep for now
window.userAPI = new UserAPI(window.APIDEF);

export default UserAPI;
